<footer class="footer" style="position: fixed;">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                {{year}} © Internal Tools.
            </div>
            <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                    Design & Develop by Stairway
                </div>
            </div>
        </div>
    </div>
</footer>